import { MultiPartField, multiPartSchema } from './MultiPartField';
import type { FieldPart, FormFieldComponent } from './types-reexport';

const PARTS: readonly FieldPart[] = [
  { role: 'dayFormField', fallbackName: 'day' },
  { role: 'monthFormField', fallbackName: 'month' },
  { role: 'yearFormField', fallbackName: 'year' },];

const GenericFormDateField: FormFieldComponent = () => <MultiPartField parts={PARTS} />;

GenericFormDateField.formSchema = content => multiPartSchema(content, PARTS);

export default GenericFormDateField;
